<template lang="pug">
  #BindSaRecommendIndex.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.w-100(
      style="padding-bottom: 20px;flex: 1 1 0;",
    )
      b-card.border-0.my-4(
        bg-variant="white"
      )
        .text-center
          small.d-block.mb-2 恭喜您已為 TIFFANY & CO. 摯友。
          small.d-block.mb-3 請選擇您的喜好專門店，
          small.d-block.mb-3 我們將指派專屬CA為您服務，
          small.d-block.mb-3 可以隨時與您的專屬CA進行線上一對一諮詢。
        ValidationObserver(
          ref="userForm"
          tag="form"
          @submit.stop.prevent="submitHandler"
        )
          b-form-group(
            class="mb-0"
          )
            ValidationProvider(
              rules="required",
              ref="inputValMobile",
              v-slot="{ errors }"
            )
              .row.justify-content-center.mb-4
                .col-10
                  b-form-select(
                    id="store",
                    required,
                    v-model="userForm.store_reference",
                    :state="validState('store_reference')",
                    aria-describedby="input-live-help input-name-live-feedback",
                    placeholder="請選擇居住區域",
                    class="rounded-0 bg-light border-black text-center"
                  )
                    template(
                      v-slot:first
                    )
                      b-form-select-option(
                        :value="null",
                        disabled
                      ) 請選擇喜好專門店
                    b-form-select-option(
                      v-for="(store,index) in storeDropdown",
                      :key="store.title",
                      :value="store.id"
                    ) {{ store.title }}
                  b-form-invalid-feedback(
                    id="input-name-live-feedback"
                  )
                    span {{ errors[0] }}
    .footer.bg-white.w-100.pb-4
      b-button(
        variant="primary",
        block,
        @click="submitHandler()",
        class="rounded-0 text-black border-gray"
      ) 確認
</template>

<script>
import { mapState } from 'vuex';
import { M_BIND_SA_SUCCESS } from '@/router/member/bind-sa';
import { M_SIGN_UP_INDEX } from '@/router/member/sign-up';

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'BindSaRecommendIndex',
  components: {
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      userForm: {
        store_reference: null
      },
      line_uuid: '',
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);

    vm.$swal.fire({
      title: '請稍候，資料取得中',
      allowOutsideClick: false,
      onOpen: function onOpen() {
        vm.$swal.showLoading();
      }
    });
    vm.$store.dispatch('member_bind_sa/checkMemberBindHandler')
      .then((res) => {
        vm.line_uuid = res.line_uuid;
        window.sessionStorage.setItem('line_uuid', vm.line_uuid);
        if (res.type === 'not_binding') {
          vm.$router.push({ name: M_SIGN_UP_INDEX });
        }
        if (res.type === 'bind_member' && res.user.sa_id !== 0 && res.user.sa_id !== null) {
          vm.$store.dispatch('member_my_sa/getSaProfileHandler').then(() => {
            vm.$swal.fire({
              title: '您已綁定CA，您目前綁定的專屬CA為',
              html: `${vm.member_sa_info.stores[0].title}<br>${vm.member_sa_info.preferred_name}`,
              icon: 'info'
            }).then(() => {
              window.location.href = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
            });
          });
        } else if (res.type === 'unbind_member') {
          const queryString = window.location.search.split('?directBy=')[1];
          if (queryString === 'sticker' || vm.$route.params.directBy === 'sticker') {
            window.sessionStorage.setItem('directBy', 'sticker');
            vm.$store.commit('member_sign_up/setRedirectPage', queryString || vm.$route.params.directBy);
          }
        }
      });

    const input = {
      loginChannelId: process.env.VUE_APP_LINE_LOGIN_CHANNEL_ID,
      msgChannelId: process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID
    };
    const query = Object.keys(input).reduce((a, k) => {
      a.push(`${k }=${ encodeURIComponent(input[k])}`);
      return a;
    }, []).join('&');
    vm.$store.dispatch('member_bind_sa/getStoreDropdownHandler', query).then(() => {
      vm.$swal.close();
    });

  },
  methods: {
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.userForm.validate();
      if (!isValid) {
        if (vm.userForm.store_reference === null) {
          vm.userForm.store_reference = '';
        }
        this.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位'
        });
      } else {
        vm.bindSaHandler();
      }
    },
    bindSaHandler() {
      const vm = this;
      vm.$swal.fire({
        allowOutsideClick: false,
        onOpen: function onOpen() {
          vm.$swal.showLoading();
        }
      });
      vm.$store.dispatch('member_bind_sa/memberBindingSaByStoreHandler', vm.userForm).then(() => {
        vm.$swal.close();
        vm.$router.push({
          name: 'm-bind-sa-success',
          params: {
            line_uuid: vm.line_uuid
          }
        });
      });
    }
  },
  computed: {
    ...mapState({
      storeDropdown: (state) => state.member_bind_sa.storeDropdown,
      member_sa_info: (state) => state.member_my_sa.saData
    })
  }
};
</script>

<style>

</style>
